import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { flexRender } from '@tanstack/react-table';

import Styles from '../stripboard.module.scss';

export const StripboardTableHeaderCell = ({ header }: { header: any }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: header.id,
    data: {
      type: 'column',
      column: header,
    },
    disabled: header.column.getIsResizing() || header.column.getIsPinned(),
    animateLayoutChanges: () => true,
    transition: {
      duration: 150,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 4 : 1,
    width: header.getSize(),
  };

  const [isResizing, setIsResizing] = React.useState(false);

  const handleResizeStart = (e: React.MouseEvent | React.TouchEvent) => {
    e.stopPropagation();
    setIsResizing(true);
    header.getResizeHandler()(e);
  };

  const handleResizeEnd = () => {
    setIsResizing(false);
  };

  React.useEffect(() => {
    if (isResizing) {
      document.addEventListener('mouseup', handleResizeEnd);
      document.addEventListener('touchend', handleResizeEnd);
    }
    return () => {
      document.removeEventListener('mouseup', handleResizeEnd);
      document.removeEventListener('touchend', handleResizeEnd);
    };
  }, [isResizing]);

  return (
    <div
      ref={setNodeRef}
      className={Styles.headerCell}
      style={style}
      {...attributes}
      {...listeners}
    >
      <span>
        {header.isPlaceholder
          ? null
          : flexRender(header.column.columnDef.header, header.getContext())}
      </span>

      <div
        onMouseDown={handleResizeStart}
        onTouchStart={handleResizeStart}
        className={Styles.resizerContainer}
      >
        <div
          className={`${Styles.resizer} ${header.column.getIsResizing() ? Styles.isResizing : ''}`}
        />
      </div>
    </div>
  );
};
